import {findIndex} from 'lodash';

const key = 'recentlyViewed_ids';
const maxItems = 4;

const saveRecentlyViewed = (item) => {
	// Get the existing data
	let existing = localStorage.getItem(key);

	// If no existing data, create an array
  if (!existing) {
    localStorage.setItem(key, '[]');
  }
  const lsItems = localStorage.getItem(key);

	// Otherwise, convert the localStorage string to an array
	let items = JSON.parse(lsItems);

  // If the item exists then cancel
  if (items.indexOf(item) !== -1) {
    return
  }
  // if (findIndex(items, {seriesId: item.seriesId}) !== -1) {
  //   return
  // }

	// Add new data to localStorage Array
  if (items && findIndex(items, item) === -1) {
    // Save back to localStorage
    if (items.length >= maxItems) {
      items.pop();
    }
    // Concat to first in array 
    localStorage.setItem(key, JSON.stringify([item].concat(items)));
  }

}

const getRecentlyViewed = () => {
  if (typeof window !== 'undefined') {
    return JSON.parse(localStorage.getItem(key));
  } else {
    return []
  }
}

export {getRecentlyViewed, saveRecentlyViewed}
